export const ProgressBar = ({
  completed,
  total,
  failed,
}: {
  completed: number;
  total: number;
  failed: number;
}) => {
  if (total === 0) return <span className="text-xs text-gray-400">No tasks</span>;

  const completedPct = (completed / total) * 100;
  const failedPct = (failed / total) * 100;

  return (
    <div className="flex items-center gap-2 min-w-[200px]">
      <div className="w-28 h-2 rounded-full bg-gray-200 overflow-hidden flex shrink-0">
        {completedPct > 0 && (
          <div className="bg-green-500 h-full" style={{ width: `${completedPct}%` }} />
        )}
        {failedPct > 0 && <div className="bg-red-500 h-full" style={{ width: `${failedPct}%` }} />}
      </div>
      <span className="text-xs text-gray-600 whitespace-nowrap">
        {completed}/{total}
      </span>
    </div>
  );
};
